module.exports = __webpack_public_path__ + "img/jsleague.6db9a8b7.png";